import { useAppContext } from '../../context/AppContext';
import { isEcoBeamDesign } from '../../utils/ecoBeamPricing';
import {
    ECO_BEAM_ORDER_CONTACT_PHONE,
    LEAD_TIME_EXPEDITE_CONTACT_EMAIL,
} from '../../utils/leadTime';

export const LeadTimeNotice = ({ designs = [] } = {}) => {
    const { currentLeadTime } = useAppContext();
    const hasEcoBeamDesigns = designs.some(isEcoBeamDesign);

    return (
        <div className="lead-time-notice" role="status">
            <p className="lead-time-notice__text">
                <strong>Current Project Lead Time:</strong> {currentLeadTime}.{' '}
                Contact us at{' '}
                <a href={`mailto:${LEAD_TIME_EXPEDITE_CONTACT_EMAIL}`}>
                    {LEAD_TIME_EXPEDITE_CONTACT_EMAIL}
                </a>{' '}
                if you would like to expedite your project.
            </p>
            {hasEcoBeamDesigns && (
                <p className="lead-time-notice__text lead-time-notice__text--secondary">
                    Eco-Beam designs are not available for online quoting. To order Eco-Beam, please call{' '}
                    <a href={`tel:${ECO_BEAM_ORDER_CONTACT_PHONE.replace(/[^\d+]/g, '')}`}>
                        {ECO_BEAM_ORDER_CONTACT_PHONE}
                    </a>{' '}
                    or email{' '}
                    <a href={`mailto:${LEAD_TIME_EXPEDITE_CONTACT_EMAIL}`}>
                        {LEAD_TIME_EXPEDITE_CONTACT_EMAIL}
                    </a>
                    .
                </p>
            )}
        </div>
    );
};
